import { Box, Divider, Flex, ScrollArea, Stack } from '@mantine/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SmallSquareButton } from '../../../../../components/small-square-button/small-square-button';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setThroughputMode } from '../../../../../store/strategy-store/strategy-store.actions';
import { Select } from '../../../../../ui-library/select/select';
import { useCurrentStrategyTab } from '../../../strategy.hooks';
import { ThroughputMode } from '../../initiative-performance.type';
import { FiltersEpics } from './filters-epics';
import { FiltersInitiatives } from './filters-initiatives';
import { FiltersOutcomes } from './filters-outcomes';
import { FiltersProgress } from './filters-progress';
import { FiltersTeams } from './filters-teams';
import { getThroughputModeOptions } from './filters.helpers';

export const Filters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const { t } = useTranslation();
  const throughputMode = useThroughputTabStore((state) => state.mode);
  const currentStrategyTab = useCurrentStrategyTab();

  const throughputModeOptions = getThroughputModeOptions(currentStrategyTab, t);

  useEffect(() => {
    const validOptionValues = throughputModeOptions.map((option) => option.value);
    if (!validOptionValues.includes(throughputMode) && throughputModeOptions.length > 0) {
      setThroughputMode(throughputModeOptions[0].value as ThroughputMode);
    }
  }, [throughputMode, throughputModeOptions]);

  return (
    <Stack gap="md" h="100%">
      <Flex gap={8} align="center">
        <Box style={{ flex: 1 }}>
          <Select
            options={throughputModeOptions}
            value={throughputMode}
            onChange={(value) => setThroughputMode(value as ThroughputMode)}
          />
        </Box>
        <SmallSquareButton onClick={() => setShow(false)} iconName="arrow_back_ios" />
      </Flex>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0} style={{ flex: 1 }}>
        {throughputMode === ThroughputMode.InitiativeProgress && <FiltersProgress />}
        {throughputMode === ThroughputMode.ContributingEpics && <FiltersEpics />}
        {throughputMode === ThroughputMode.ContributingTeams && <FiltersTeams />}
        {throughputMode === ThroughputMode.ContributingInitiatives && <FiltersInitiatives />}
        {throughputMode === ThroughputMode.ContributingOutcomes && <FiltersOutcomes />}
      </ScrollArea>
    </Stack>
  );
};
